export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/25f6916705eac38cd08112fe3bfef7f3.jpg";